
import APIConstant from '../utils/pathConstants';
import api from '../utils/apiClient';
import Cookies from 'js-cookie';
import Toast from '../components/Shared/Toast/Toast';

export default class CommonConfig {

    static isEmpty = function (value) {
        if (value === undefined || value === null || value === '' || value === 'null') {
            return true;
        } else {
            if (typeof value === 'string') {
                return value.trim() === "";
            } else {
                return false;
            }
        }
    }

    static isObjectEmpty = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    static filterTwoArray = function (data, filters) {
        return data.filter(e => {
            try {
                filters.forEach(o => {
                    Object.keys(o).forEach(key => {
                        if (e[key] !== o[key]) throw new 1;
                    });
                });

                return true;
            } catch (e) {
                return false;
            }
        });
    }

    static getDatesBetweenDates = function (startDate, endDate) {
        let dates = []
        //to avoid modifying the original date
        const theDate = new Date(startDate)
        while (theDate < endDate) {
            dates = [...dates, new Date(theDate)]
            theDate.setDate(theDate.getDate() + 1)
        }
        // dates = [...dates, endDate]
        dates.splice(0, 1)
        return dates
    }

    static amountValidate = function (e) {
        var t = e;
        e = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t.indexOf("-") != -1 ? t.substr(1, t.length) : t;
        // console.log("t",e)
        return e;
    }

    static addDaysToDates = function (date, noOfDays) {
        var theDate = date;
        theDate.setDate(theDate.getDate() + noOfDays);
        return theDate;
    }

    static dateFormat = {
        dateTime: 'MM/DD/YYYY hh:mm:ss A',
        dateOnly: 'MM/DD/YYYY',
        dateFirst: 'DD/MM/YYYY',
        forDatePicker: 'DD-MM-YYYY',
        yearOnly: 'YYYY',
        dbDateTime: 'YYYY-MM-DD HH:mm:ss',
        timeOnly: 'HH:mm'
    }

    static loginData = function () {
        if (localStorage.getItem('ERPLoginData')) {
            return JSON.parse(localStorage.getItem('ERPLoginData'));
        }
        else {
            return ""
        }
        // const data = Cookies.get('ERPLoginData');
        // return JSON.parse(data);
    }

    static getUserAccess = function (moduleName) {
        if (this.getCookie('ERPLoginData')) {
            let data = JSON.parse(localStorage.getItem('userAccessData'));
            let moduleAccess = data?.filter(x => x?.ServiceName === moduleName);
            const accessData = moduleAccess ? moduleAccess[0]?.AccessMasterList : {};
            return accessData;

        } else {
            return ""
        }
    }

    static randomString = function (length) {
        // var length = 32; 
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    static getPanNumberFromGST = function (gst) {
        // var length = 32; 
        if (gst) {
            var result = gst.substr(2, 10);
        }
        // const strPattern = ["[A-Z]{5}[0-9]{4}[A-Z]{1}"];
        // for (let i = 0; i < 1; i++) {
        //     const pattern = new RegExp(strPattern[i]);
        //     const words_begin = gst.matchAll(pattern);
        //     console.log("The PAN Number that above string contains:");
        //     for (const match of words_begin) {
        //         console.log(match[0]);
        //         result = match[0]
        //     }
        // }
        return result;
    }

    static ExcelDateToJSDate = function (serial) {
        var utc_days = Math.floor(serial - 25569);
        var utc_value = utc_days * 86400;
        var date_info = new Date(utc_value * 1000);

        var fractional_day = serial - Math.floor(serial) + 0.0000001;

        var total_seconds = Math.floor(86400 * fractional_day);

        var seconds = total_seconds % 60;

        total_seconds -= seconds;

        var hours = Math.floor(total_seconds / (60 * 60));
        var minutes = Math.floor(total_seconds / 60) % 60;

        return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    }

    static convertImgToBase64 = async function (url) {
        return fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(blob)
            }))
    }

    static base64toFile = function (dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    static findFileNameFromURL = function (urlPath) {
        var url = urlPath;
        var filename = url.substring(url.lastIndexOf('/') + 1);
        return filename;
    }

    static findExtesionFromURL = function (urlPath) {
        const types = new Map([["jpg", "img"], ["jpeg", "img"], ["png", "img"], ["gif", "img"], ["mp4", "video"], ["3gp", "video"]])

        const url = new URL(urlPath)
        return url.pathname.split(".")[1]
    }

    static filterCaseInsensitive = function (filter, row) {
        const id = filter.pivotId || filter.id;
        const content = row[id];

        if (typeof content !== 'undefined') {
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {
                return String(content).toLowerCase().includes(filter.value.toLowerCase());
            }
        }

        return true;
    }

    static getIndianFormatAmount = function (amount) {
        var x = amount;
        x = x.toString();
        var afterPoint = '';
        if (x.indexOf('.') > 0)
            afterPoint = x.substring(x.indexOf('.'), x.length);
        x = Math.floor(x);
        x = x.toString();
        var lastThree = x.substring(x.length - 3);
        var otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers != '')
            lastThree = ',' + lastThree;
        return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
    }

    static RegExp = {
        phoneRegExp: /^([0-9]+\s?)*$/g,
        RateRegex: /^(\$|)([1-9]\d{0,2}(\.\d{2})*|([1-9]\d*))(\.\d{2})?$/,
        number: /^[0-9\b]+$/,
        onlyNumber: /[a-zA-Z~`!@#$%^&*()_+=-{}|:"<>?,;']+$/,
        // onlyDecimal: /^[0-9]+(\.[0-9][0-9])?$/,
        onlyDecimal: /^\d*\.?\d{0,2}$/,
        phoneNumber: /^([0-9]+\s?)*$/g,
        // email : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9-]+\.[A-Z]{2,6}$/ig,
        email: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        CompanyName: /[!@~`#$%^&*()_+\-=\]{};':"\\|,.<>?]/,
        zipCode: /^([a-zA-Z0-9]+\s?)*$/g,
        regExpNumber: /[0-9]/g,
        regExpUpperCase: /[A-Z]/g,
        regExpLowerCase: /[a-z]/g,
        phone: /^[0-9]{10}$/,
        regExpSpecialCharacter: /[!@#$%^&*(),.?":{}|<>]/g,
        RateRegex: /^(\$|)([1-9]\d{0,3}(\.\d{3})*|([1-9]\d*))(\.\d{3})?$/
    }

    static showErrorMsg = function (msg) {
        return (
            <span className="text-danger" style={{ color: 'red' }}>
                <span className="field-validation-error">{msg}</span>
            </span>
        )
    }

    static getUserMenu = async (userData, navigate, type) => {
        try {
            if (userData?.UserRole === 'Parent' && type === 'Login') {
                navigate('/childreen-list');
            } else {
                const data = { UserId: userData?._id, RoleId: userData?.UserType };
                const res = await api.post(APIConstant.path.getUserMenu, data);
                if (res.success) {
                    if (res.data.length) {
                        let redirectPath = (res.data[0]?.ParentId == '' || res.data[0]?.ParentId == null) ? res.data[0]?.Children[0]?.Path : res.data[0]?.Path;
                        navigate((redirectPath == '' || redirectPath == null) ? '/edit-profile' : redirectPath);
                    } else {
                        navigate('/edit-profile');
                    }
                }
            }
        } catch (err) {
            console.error('Error fetching user menu:', err);
        }
    };

    static getCookie(key) {
        const data = localStorage.getItem(key);
        return data;
    }

    static setCookie(key, value) {
        localStorage.setItem(key, value);
    }

    static removeCookie(key) {
        localStorage.removeItem(key);
    }

    static handleLogout = async (id, navigate) => {
        try {
            let data = {
                id: id
            };
            const res = await api.post(APIConstant.path.logout, data);
            if (res.success) {
                localStorage.clear();
                CommonConfig.removeCookie('access_token');
                CommonConfig.removeCookie('refresh_token');
                CommonConfig.removeCookie('ERPLoginData');
                CommonConfig.removeCookie('loggedIn');
                CommonConfig.removeCookie('refreshValue');
                CommonConfig.removeCookie('userAccessData');
                CommonConfig.removeCookie('_grecaptcha');
                navigate('/login');
                Toast.success({ message: 'Logged out successfully' });
            }
        } catch (err) {

        }
    };

    static handleCatchLogout = async (navigate) => {
        localStorage.clear();
        CommonConfig.removeCookie('access_token');
        CommonConfig.removeCookie('refresh_token');
        CommonConfig.removeCookie('ERPLoginData');
        CommonConfig.removeCookie('loggedIn');
        CommonConfig.removeCookie('refreshValue');
        CommonConfig.removeCookie('_grecaptcha');
        CommonConfig.removeCookie('userAccessData');
        navigate('/login');
        Toast.success({ message: 'Logged out successfully' });
    };
}